module.exports = __webpack_public_path__ + "img/lcf_csf_lockup-4fa989d.png";


//////////////////
// WEBPACK FOOTER
// ./source/assets/img/lcf_csf_lockup.png
// module id = 143
// module chunks = 0